import { useQuery } from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { payoutsKeys } from "../payouts.utils"
import type { ResponseDto, BalanceTransactionDto } from "@mimber/schema"

/**
 * Get transaction breakdown for a specific payout
 * GET /organization/payouts/:payoutId/transactions
 */
export const usePayoutTransactions = (payoutId: string) => {
  guardAppUsage("mimber-organization", "usePayoutTransactions")

  const { server } = useServerContext()

  return useQuery<ResponseDto<BalanceTransactionDto[]>, Error>({
    queryKey: payoutsKeys.getTransactions(payoutId),
    queryFn: async () => {
      const response = await server.get(
        `/organization/payouts/${payoutId}/transactions`
      )
      return response.data
    },
    enabled: !!payoutId,
  })
}
